export const seriesRecordingRetrievedProperties = ['createDate', 'epgId', 'id', 'seriesId', 'type'].join(',');
export const recordingRetrievedProperties = ['createDate', 'assetId', 'id', 'status', 'type', 'viewableUntilDate'].join(
  ',',
);
